import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ListContainer } from '../../styles/styles';

interface IProps {
  title: string;
  cards: React.ReactNode;
}

const CardContainer: React.FC<IProps> = ({ title, cards }) => {
  return (
    <ListContainer style={{ marginTop: '20px' }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h5'>{title}</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {cards}
      </Grid>
    </ListContainer>
  );
};

export default CardContainer;
